import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import { SegmentedButtonsGroup } from "../segmentedButtonsGroup/SegmentedButtonsGroup";
import { useIntlTranslate } from "../../hooks";

export const periods = [
  { value: "1", name: "24_hours", mobileName: "day_noun" },
  { value: "7", name: "7_days", mobileName: "week_noun" },
  { value: "30", name: "30_days", mobileName: "month_noun" },
];
const buttons = periods.map(({ value, mobileName }) => ({
  value,
  node: <FormattedMessage id={mobileName} />,
}));

export const TimePeriodSegmentedButtons = ({ selectedValue, onChange }) => {
  const translate = useIntlTranslate();

  return (
    <SegmentedButtonsGroup
      label={<FormattedMessage id="show_results_period" />}
      groupName="time-period"
      selectedValue={selectedValue}
      buttons={buttons}
      onChange={onChange}
      ariaGroupLabel={translate("show_results_period_group_label")}
      hideLegendFromScreenReader={true}
    />
  );
};

TimePeriodSegmentedButtons.propTypes = {
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
